import apiClient from 'api/apiClient';
import API_END_POINT from 'constants/apiEndPoints';
import { ApiResponse } from 'types';

interface UploadUserImageParams {
  file: File;
}

type UpdateUserImage = (params: UploadUserImageParams) => Promise<ApiResponse>;

const updateUserImage: UpdateUserImage = async ({ file }) => {
  const formData = new FormData();
  formData.append('file', file);

  const { data } = await apiClient.put(API_END_POINT.USER.UPDATE_USER_IMAGE, formData);

  return data;
};

export default updateUserImage;
